import { AutoMap } from "@automapper/classes"

export class SoufflageDTO {
    @AutoMap()
    code: string = ''
    @AutoMap()
    longueur?: number
    @AutoMap()
    largeur?: number
    @AutoMap()
    surface?: number
    @AutoMap()
    vitesse?: number

}